<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">

  <div class="bg-card flex min-w-0 flex-auto flex-col dark:bg-transparent sm:absolute sm:inset-0 sm:overflow-hidden">
    <!-- Header -->
    <div
      class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
      <div class="flex shrink-0">
        <!-- Title -->
        <!--<div class="text-3xl font-extrabold tracking-tight">Ubicación 5</div> -->
        <!-- Search -->
        <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
          <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
          <input matInput placeholder="Buscar" autocomplete="off" (input)="onSearchChange($event)" />
        </mat-form-field>
      </div>
      <!-- Actions -->
      <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
        <!-- Show filters button -->
        <button mat-stroked-button color="primary" (click)="sidenav.toggle()" matTooltip="Mostrar filtros">
          <mat-icon svgIcon="filter_list"></mat-icon>
          <span>Filtrar por</span>
        </button>
        <!-- Add button (only icon) -->
        <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Crear nuevo">
          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
        </button>
      </div>
    </div>

    <!-- Main Content (Table and Paginator) -->
    <div class="flex flex-auto overflow-hidden flex-col">
      <!-- Tabla -->
      <div class="container mt-0 flex-auto flex-col overflow-x-auto">
        <!-- Header -->
        <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
          <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSource" matSort
            [trackBy]="trackByFn">
            <!-- Código -->
            <!-- <ng-container matColumnDef="codigo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Código</th>
              <td mat-cell *matCellDef="let location" class="pl-10 text-left"><b>{{ location.code }}</b></td>
            </ng-container> -->

            <!-- Nombre -->
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Nombre</th>
              <td mat-cell *matCellDef="let location" class="px-6 text-left">
              <div>
                <b class="f-10">{{location.code}}</b>
              </div>
                {{ location.name }}
              </td>
            </ng-container>

            <!-- País -->
            <ng-container matColumnDef="locationOne">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">País</th>
              <td mat-cell *matCellDef="let location" class="px-6 text-left">
                <div><b>{{ location.locationOne.code }}</b></div>
                <div>{{ location.locationOne.name }}</div>
              </td>
            </ng-container>

            <!-- Departamento -->
            <ng-container matColumnDef="locationTwo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Departamento</th>
              <td mat-cell *matCellDef="let location" class="px-6 text-left">
                <div><b>{{ location.locationTwo.code }}</b></div>
                <div>{{ location.locationTwo.name }}</div>
              </td>
            </ng-container>

            <!-- Ciudad -->
            <ng-container matColumnDef="locationThree">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Ciudad</th>
              <td mat-cell *matCellDef="let location" class="px-6 text-left">
                <div><b>{{ location.locationThree.code }}</b></div>
                <div>{{ location.locationThree.name }}</div>
              </td>
            </ng-container>

            <!-- Colonia -->
            <ng-container matColumnDef="locationFour">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Colonia</th>
              <td mat-cell *matCellDef="let location" class="px-6 text-left">
                <div><b>{{ location.locationFour.code }}</b></div>
                <div>{{ location.locationFour.name }}</div>
              </td>
            </ng-container>

            <!-- Estado -->
            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
              <td mat-cell *matCellDef="let location" class="px-6 text-left">
                <mat-slide-toggle class="custom-slide-toggle primary" [checked]="location.statusId == 1"
                  [(ngModel)]="location.statusId" [color]="'success'"
                  (ngModelChange)="onStatusChange($event, location)">
                </mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Acciones -->
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
              <td mat-cell *matCellDef="let location" class="px-6 py-3 text-left">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button mat-menu-item (click)="openEditModal(location)">
                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    <span>Editar</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteDialog(location)">
                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    <span>Eliminar</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

            <!-- Fila principal -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
          </table>
        </div>
      </div>

      <!-- Paginación -->
      <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
        <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
          [pageIndex]="pageIndex" [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Crear Ubicación 5</h2>
      <mat-dialog-content class="modal-content">
        <form #createForm="ngForm">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Código</mat-label>
            <input matInput [(ngModel)]="currentCreateLocation.code" name="code" required>
          </mat-form-field>
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentCreateLocation.name" name="name" required>
          </mat-form-field>

          <!-- Select País (LocationOne) -->
          <mat-form-field class="modal-input">
            <mat-label>País</mat-label>
            <mat-select [(ngModel)]="currentCreateLocation.locationOneId"
              (selectionChange)="onLocationOneSelectionChange([currentCreateLocation.locationOneId])"
              name="locationOneId" required>
              <mat-option *ngFor="let location of locationOneList" [value]="location._id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Select Departamento (LocationTwo) -->
          <mat-form-field class="modal-input">
            <mat-label>Departamento</mat-label>
            <mat-select [(ngModel)]="currentCreateLocation.locationTwoId"
              (selectionChange)="onLocationTwoSelectionChange([currentCreateLocation.locationTwoId])"
              name="locationTwoId" required>
              <mat-option *ngFor="let location of filteredLocationTwoList" [value]="location._id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Select Ciudad (LocationThree) -->
          <mat-form-field class="modal-input">
            <mat-label>Ciudad</mat-label>
            <mat-select [(ngModel)]="currentCreateLocation.locationThreeId"
              (selectionChange)="onLocationThreeSelectionChange([currentCreateLocation.locationThreeId])"
              name="locationThreeId" required>
              <mat-option *ngFor="let location of filteredLocationThreeList" [value]="location._id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Select Colonia (LocationFour) -->
          <mat-form-field class="modal-input">
            <mat-label>Colonia</mat-label>
            <mat-select [(ngModel)]="currentCreateLocation.locationFourId" name="locationFourId" required>
              <mat-option *ngFor="let location of filteredLocationFourList" [value]="location._id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createLocation()"
          [disabled]="!createForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Ubicación 5</h2>
      <mat-dialog-content class="modal-content">
        <form #editForm="ngForm">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentUpdateLocation.name" name="name" required>
          </mat-form-field>

          <!-- Select País (LocationOne) -->
          <mat-form-field class="modal-input">
            <mat-label>País</mat-label>
            <mat-select [(ngModel)]="currentUpdateLocation.locationOne._id"
              (selectionChange)="onLocationOneSelectionChange([currentUpdateLocation.locationOne._id])"
              name="locationOneId" required>
              <mat-option *ngFor="let location of locationOneList" [value]="location._id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Select Departamento (LocationTwo) -->
          <mat-form-field class="modal-input">
            <mat-label>Departamento</mat-label>
            <mat-select [(ngModel)]="currentUpdateLocation.locationTwo._id"
              (selectionChange)="onLocationTwoSelectionChange([currentUpdateLocation.locationTwo._id])"
              name="locationTwoId" required>
              <mat-option *ngFor="let location of filteredLocationTwoList" [value]="location._id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Select Ciudad (LocationThree) -->
          <mat-form-field class="modal-input">
            <mat-label>Ciudad</mat-label>
            <mat-select [(ngModel)]="currentUpdateLocation.locationThree._id"
              (selectionChange)="onLocationThreeSelectionChange([currentUpdateLocation.locationThree._id])"
              name="locationThreeId" required>
              <mat-option *ngFor="let location of filteredLocationThreeList" [value]="location._id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Select Colonia (LocationFour) -->
          <mat-form-field class="modal-input">
            <mat-label>Colonia</mat-label>
            <mat-select [(ngModel)]="currentUpdateLocation.locationFour._id" name="locationFourId" required>
              <mat-option *ngFor="let location of filteredLocationFourList" [value]="location._id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="updateLocation(currentUpdateLocation._id)"
          [disabled]="!editForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <!-- Filtros -->
  <mat-sidenav #sidenav mode="side" position="end" class="mat-sidenav-content p-0" closed>
    <div class="flex items-center justify-between bg-blue-950 text-white p-4">
      <mat-icon svgIcon="filter_list" class="text-white mr-2 w-4 h-4"></mat-icon>
      <h2 class="text-current text-lg font-bold">Filtros</h2>
      <button mat-icon-button class="ml-auto" (click)="sidenav.close()" matTooltip="Cerrar">
        <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>

    <div class="mt-6 px-4">
      <!-- País (LocationOne) -->
      <div class="w-full mb-4">
        <label for="country-select" class="block text-gray-700">País</label>
        <hr class="m-1">
        <ng-select [(ngModel)]="selectedLocationOneIds" [items]="locationOneList" bindLabel="name" bindValue="_id"
          [multiple]="true" placeholder="Seleccione País" [compareWith]="compareById"
          (ngModelChange)="onLocationOneSelectionChange($event)">
        </ng-select>
      </div>

      <!-- Departamento (LocationTwo) -->
      <div class="w-full mb-4">
        <label for="department-select" class="block text-gray-700">Departamento</label>
        <hr class="m-1">
        <ng-select [(ngModel)]="selectedLocationTwoIds" [items]="filteredLocationTwoList" bindLabel="name"
          bindValue="_id" [multiple]="true" placeholder="Seleccione Departamento" [compareWith]="compareById"
          (ngModelChange)="onLocationTwoSelectionChange($event)">
        </ng-select>
      </div>

      <!-- Ciudad (LocationThree) -->
      <div class="w-full mb-4">
        <label for="city-select" class="block text-gray-700">Ciudad</label>
        <hr class="m-1">
        <ng-select [(ngModel)]="selectedLocationThreeIds" [items]="filteredLocationThreeList" bindLabel="name"
          bindValue="_id" [multiple]="true" placeholder="Seleccione Ciudad" [compareWith]="compareById"
          (ngModelChange)="onLocationThreeSelectionChange($event)">
        </ng-select>
      </div>

      <!-- Colonia (LocationFour) -->
      <div class="w-full mb-4">
        <label for="colonia-select" class="block text-gray-700">Colonia</label>
        <hr class="m-1">
        <ng-select [(ngModel)]="selectedLocationFourIds" [items]="filteredLocationFourList" bindLabel="name"
          bindValue="_id" [multiple]="true" placeholder="Seleccione Colonia" [compareWith]="compareById">
        </ng-select>
      </div>
    </div>

    <div class="flex justify-between mt-4 px-4">
      <button mat-button class="align-left text-gray-700 border border-gray-300"
        (click)="clearFilters()">Limpiar</button>
      <button mat-raised-button class="ml-auto bg-blue-950 text-white" (click)="findAllWithCount()">Aplicar</button>
    </div>
  </mat-sidenav>
</mat-sidenav-container>